import { useFeatureFlag } from '@newfront-insurance/admin-ui';

import { MSGraphToggle } from '../../ms-graph';

/**
 * Outlook Connect settings component that displays a toggle switch for enabling/disabling Outlook Connect.
 * Uses MSGraphToggle primitive to manage Outlook Connect state.
 */
export function OutlookConnectSettings() {
  const isMSGraphAuthEnabled = useFeatureFlag('nova-tools-graph-api', false);

  // Don't render if feature flag is disabled
  if (!isMSGraphAuthEnabled) {
    return null;
  }

  return (
    <div className="flex flex-col">
      {/* First row: Outlook Connect label with toggle */}
      <div className="flex items-center justify-between px-0 py-2">
        <h3 className="font-medium">Outlook Connect</h3>
        <MSGraphToggle />
      </div>

      {/* Divider */}
      <div className="border-border w-full border-t" />

      {/* Second row: Description */}
      <div className="flex flex-col gap-2 px-0 py-2">
        <p className="text-muted-foreground text-sm">Allow Nova to access your Outlook inbox</p>
      </div>
    </div>
  );
}
